import React, { useRef } from 'react';
import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { find, findIndex } from 'lodash';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { Tabs } from 'antd';

const DraggableTabNode = ({ index, id, moveTabNode, canDrag, children }) => {
  const ref = useRef(null);

  const [, drag] = useDrag(
    {
      type: 'tab',
      item: () => ({ type: 'tab', id, index }),
      canDrag: canDrag,
    },
    [index],
  );

  const [, drop] = useDrop({
    accept: 'tab',
    hover: (item, monitor) => {
      if (!monitor.didDrop()) {
        const dragIndex = item.index;
        const hoverIndex = index;

        if (dragIndex === hoverIndex) {
          return;
        }
        moveTabNode(dragIndex, hoverIndex);
      }
    },
  });

  drag(drop(ref));

  return (
    <div style={{ display: 'inline' }} ref={ref}>
      {children}
    </div>
  );
};

class DraggableTabs extends React.Component {
  moveTabNode = (dragKey, hoverKey) => {
    const { onDragEnd, dataList } = this.props;
    const newOrder = [...dataList];

    const dragIndex = findIndex(newOrder, (item) => String(item.id) === dragKey);
    const hoverIndex = findIndex(newOrder, (item) => String(item.id) === hoverKey);
    const targetItem = find(newOrder, (item) => String(item.id) === dragKey);
    newOrder.splice(dragIndex, 1);
    newOrder.splice(hoverIndex, 0, targetItem);

    onDragEnd(newOrder);
  };

  renderTabBar = (props, DefaultTabBar) => (
    <DefaultTabBar {...props}>
      {(node) => {
        return (
          <DraggableTabNode key={node.key} index={node.key} moveTabNode={this.moveTabNode} canDrag={this.props.canDrag}>
            {node}
          </DraggableTabNode>
        );
      }}
    </DefaultTabBar>
  );

  render() {
    // canDrag, list, dataList, onDragEnd는 antd Tabs에 전달하지 않음
    const { items, list, canDrag, dataList, onDragEnd, ...tabsProps } = this.props;

    // items를 list 순서에 맞게 정렬
    const orderedItems = items
      ? [...items].sort((a, b) => {
          const aKey = String(a.key);
          const bKey = String(b.key);

          const orderA = list ? list.findIndex((item) => String(item.id) === aKey) : -1;
          const orderB = list ? list.findIndex((item) => String(item.id) === bKey) : -1;

          if (orderA !== -1 && orderB !== -1) {
            return orderA - orderB;
          }
          if (orderA !== -1) {
            return -1;
          }
          if (orderB !== -1) {
            return 1;
          }
          return 0;
        })
      : [];

    // canDrag가 false이면 DndProvider 없이 렌더링
    if (!canDrag) {
      return <Tabs items={orderedItems} {...tabsProps} />;
    }

    return (
      <DndProvider backend={HTML5Backend}>
        <Tabs renderTabBar={this.renderTabBar} items={orderedItems} {...tabsProps} />
      </DndProvider>
    );
  }
}

export default DraggableTabs;
